import React from 'react';
import { Box, Typography, Grid, Paper, Button } from '@mui/material';
import { 
  TrendingUp as TrendingUpIcon,
  BarChart as BarChartIcon,
  PieChart as PieChartIcon
} from '@mui/icons-material';

/**
 * Dashboard analitik bölümü
 */
const AnalyticsSection = () => {
  return (
    <Box className="analytics-section">
      <Box className="analytics-header">
        <Typography className="analytics-title">
          Form Analitikleri
        </Typography>
        <Button 
          variant="outlined"
          startIcon={<TrendingUpIcon />}
          sx={{
            borderRadius: '8px',
            textTransform: 'none',
            borderColor: '#4158D0',
            color: '#4158D0',
            '&:hover': {
              borderColor: '#C850C0',
              color: '#C850C0',
              background: 'rgba(65, 88, 208, 0.05)',
            }
          }}
        >
          Tüm Analitikler
        </Button>
      </Box>

      <Grid container spacing={3}>
        <Grid item xs={12} md={8}>
          <Paper className="analytics-card" elevation={0}>
            <Typography variant="h6" sx={{ fontWeight: 600, color: '#2c3e50', mb: 2 }}>
              Yanıt Trendleri
            </Typography>
            <Box className="analytics-chart">
              <Box sx={{ 
                width: '100%', 
                height: '100%', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                background: 'linear-gradient(135deg, rgba(65, 88, 208, 0.05) 0%, rgba(200, 80, 192, 0.05) 100%)',
                borderRadius: '12px'
              }}>
                <BarChartIcon sx={{ fontSize: 60, color: '#4158D0', opacity: 0.2 }} />
              </Box>
            </Box>
            <Box className="analytics-legend">
              <Box className="legend-item">
                <Box className="legend-color" sx={{ background: '#4158D0' }}></Box>
                <Typography>Ocak</Typography>
              </Box>
              <Box className="legend-item">
                <Box className="legend-color" sx={{ background: '#C850C0' }}></Box>
                <Typography>Şubat</Typography>
              </Box>
              <Box className="legend-item">
                <Box className="legend-color" sx={{ background: '#2ecc71' }}></Box>
                <Typography>Mart</Typography>
              </Box>
              <Box className="legend-item">
                <Box className="legend-color" sx={{ background: '#e74c3c' }}></Box>
                <Typography>Nisan</Typography>
              </Box>
            </Box>
          </Paper>
        </Grid>
        <Grid item xs={12} md={4}>
          <Paper className="analytics-card" elevation={0}>
            <Typography variant="h6" sx={{ fontWeight: 600, color: '#2c3e50', mb: 2 }}>
              Form Türleri Dağılımı
            </Typography>
            <Box className="analytics-chart">
              <Box sx={{ 
                width: '100%', 
                height: '100%', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                background: 'linear-gradient(135deg, rgba(65, 88, 208, 0.05) 0%, rgba(200, 80, 192, 0.05) 100%)',
                borderRadius: '12px'
              }}>
                <PieChartIcon sx={{ fontSize: 60, color: '#4158D0', opacity: 0.2 }} />
              </Box>
            </Box>
            <Box className="analytics-legend">
              <Box className="legend-item">
                <Box className="legend-color" sx={{ background: '#4158D0' }}></Box>
                <Typography>Anketler</Typography>
              </Box>
              <Box className="legend-item">
                <Box className="legend-color" sx={{ background: '#C850C0' }}></Box>
                <Typography>Başvurular</Typography>
              </Box>
              <Box className="legend-item">
                <Box className="legend-color" sx={{ background: '#2ecc71' }}></Box>
                <Typography>Değerlendirmeler</Typography>
              </Box>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AnalyticsSection;
